import { ApolloError } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

import { Button } from 'play/atoms/button/Button';

import { useTrackAmplitudeEvent } from '../../../support/amplitude/amplitudeEvent';

export interface TrackReviewFeedbackFormProps {
  error?: ApolloError;
  loading?: boolean;
  onUpdateReview?(content: string): void;
}

export const TrackReviewFeedbackForm = ({ error, loading = false, onUpdateReview }: TrackReviewFeedbackFormProps) => {
  const trackAmplitudeEvent = useTrackAmplitudeEvent();
  const startedWritingRef = useRef(false);
  const [content, setContent] = useState('');
  const submitDisabled = content === '';
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (submitDisabled) return;

    onUpdateReview?.(content);
  };

  useEffect(() => {
    if (!startedWritingRef.current && content) {
      startedWritingRef.current = true;
      trackAmplitudeEvent({ name: 'Lab - Feedback - Started writing' });
    }
  }, [content, trackAmplitudeEvent]);

  return (
    <form tw="flex flex-col" onSubmit={onSubmit}>
      <h1 tw="text-4xl leading-snug text-white font-medium mb-3">What could be better?</h1>
      <textarea
        name="content"
        tw="mb-3 p-3 h-20 rounded-sm text-white outline-none resize-none overflow-auto placeholder-gray-30 text-enlarged"
        placeholder="Type your feedback here"
        style={{ background: '#3b4458' }}
        value={content}
        onChange={e => setContent(e.target.value)}
      />
      <div tw="flex items-baseline" css={error ? tw`justify-between` : tw`justify-end`}>
        {error && <p tw="text-warning text-base">Uh oh! Unable to send feedback, please try again.</p>}
        <Button disabled={submitDisabled} type="submit" loading={loading}>
          Send
        </Button>
      </div>
    </form>
  );
};
